import i18n from 'src/locale/i18n'

export enum Type {
  LINK = 'LINK',
  DIVIDER = 'DIVIVDER',
  CALLBACK = 'CALLBACK',
}

export const getNavigationConfig = (showSettings?: boolean) => [
  {
    id: 1,
    text: i18n.t('nav:myProfile'),
    icon: 'tabler:user-check',
    path: '/settings/personal/profile',
  },

  ...(showSettings
    ? [
        {
          id: 2,
          text: i18n.t('nav:settings'),
          icon: 'tabler:settings',
          path: '/settings/project/general',
        },
      ]
    : []),

  {
    id: 3,
    text: i18n.t('nav:billing'),
    icon: 'tabler:credit-card',
    path: '/settings/project/billing',
  },

  // { id: 5, type: Type.DIVIDER },
  // { id: 6, text: 'Help', icon: 'tabler:lifebuoy', path: '/help' },
  //   { id: 7, text: 'FAQ', icon: 'tabler:info-circle', path: '/' },
  // { id: 8, text: 'Pricing', icon: 'tabler:currency-dollar', path: '/' },
  { id: 9, type: Type.DIVIDER },
  {
    id: 10,
    text: i18n.t('nav:signOut'),
    icon: 'tabler:logout',
    type: Type.CALLBACK,
  },
]
